<template>
    <div id="app" :lang="lang">
        <div v-if="theme" class="bng-pageloader" :class="{'is-active':loading}">
            <div>{{client.view.general.alias}}</div>
        </div>
        <router-view v-if="!loading" />
        <modal-mbk />
    </div>
</template>

<script>
import Vue from 'vue';

import playerService from '../../_common/services/player.service';
import livechat from '../../_common/services/livechat.service';
import utils from '../../_common/utils';

import modalMbk from "../bulmasite/components/common/mbk/modal.vue";

export default {
    name: 'app',
    components: { modalMbk },
    data() {
        return {
            loading: true,
            theme: null
        };
    },
    computed: {
        client() {
            return Vue.state.client.get();
        },
        lang() {
            return Vue.state.lang.currentLang;
        },
    },
    async beforeCreate() {
        // load client
        await Vue.state.client.ensure();
        let client = Vue.state.client.get();

        // theme
        this.theme = (client && client.view && client.view.style.theme) || 'dark';

        // configured languages
        Vue.state.lang.availableLanguages = client.view.languageSettings.languages;

        // load data
        await Promise.all([
            Vue.state.games.ensure(),
            Vue.state.currencies.ensure(),
            Vue.state.timezones.ensure(),
            Vue.state.content.strings.ensure(),
            Vue.state.content.links.ensure()
        ]);

        // track player activity
        Vue.state.player.trackPlayerActivity = client.view.playerActivity.trackPlayerActivity;
        Vue.state.player.inactivityTimeout = client.view.playerActivity.playerInactivityTimeout;
        Vue.state.player.playerInactivityRoute = client.view.playerActivity.playerInactivityRoute;
        await Vue.state.player.ensureWatchingActivity();

        // load player if logged in
        await Vue.state.player.reload();

        // set site language
        Vue.state.lang.ensureLocalLangOrPlayer((Vue.state.player.isLoggedIn() && Vue.state.player.get().lang) || utils.browserLanguage());

        // set livechat events
        if (Vue.state.player.isLoggedIn()) livechat.set(Vue.state.player.get(), 'Open site');
        else livechat.set(await playerService.getAnonymous(), 'Open site anonymously');

        // subscribe push messages
        Vue.state.player.subscribePushMessages(message => Vue.$notification.push(message));

        this.loading = false;
    }
};
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/App.vue